export const checkmark = '✔️';
export const remove = '❌';
export const question = '?';
